/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreGraphHigh = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15.5 3.5V1a.5.5 0 0 0-.5-.5h-2.5a.5.5 0 0 0 0 1h1.293L8.436 6.856 5.777 5.084a.498.498 0 0 0-.63.062l-4.5 4.5a.5.5 0 1 0 .707.708l4.21-4.21 2.659 1.772a.5.5 0 0 0 .631-.062L14.5 2.207V3.5a.5.5 0 0 0 1 0zm0 11.5V6.5a.5.5 0 0 0-.864-.343l-5.764 6.129-2.964-2.031a.496.496 0 0 0-.655.079s-1.591 1.742-2.78 2.977C1.306 14.524 1 14.724 1 15s.224.5.5.5H15a.5.5 0 0 0 .5-.5z"
    />
  </svg>
);

IconCoreGraphHigh.displayName = 'IconCoreGraphHigh';

IconCoreGraphHigh.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreGraphHigh);
IconCoreGraphHigh.displayName = 'IconCoreGraphHigh';
